import bTable from './table.vue';

export default bTable;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/table/table.js
// module id = 709
// module chunks = 0